// extracted by mini-css-extract-plugin
export var container = "_it-0";
export var content = "_it-3";
export var customerTitle = "_it-4";
export var empty = "_it-5";
export var gray = "_it-6";
export var header = "_it-7";
export var info = "_it-8";
export var loading = "_it-2";
export var loadingCard = "_it-9";
export var oneLine = "_it-a";
export var personName = "_it-e";
export var pillContainer = "_it-b";
export var selected = "_it-1";
export var text = "_it-c";
export var twoLines = "_it-d";
export var unread = "_it-f";
export var unreadIndicator = "_it-g";